import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiMessageSquare } = FiIcons;

const Footer = () => {
  return (
    <footer className="relative py-12 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-r from-gray-900 via-red-900/50 to-purple-900/50"></div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center">
          {/* Logo */}
          <motion.div 
            className="flex items-center justify-center space-x-3 mb-6"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <div className="w-12 h-12 flex items-center justify-center">
              <img 
                src="https://netfills.com/wp-content/uploads/2025/08/crimson-guild-logo-1.png" 
                alt="Crimson Guild Logo" 
                className="w-full h-full object-contain drop-shadow-[0_0_8px_rgba(220,38,38,0.8)]" 
              />
            </div>
            <span className="text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-red-400 to-yellow-400">
              Crimson Guild
            </span>
          </motion.div>

          {/* Contact Info */}
          <motion.div
            className="flex items-center justify-center mb-8"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
          >
            <div className="flex items-center space-x-2 text-white">
              <SafeIcon icon={FiMessageSquare} className="text-purple-400" />
              <a 
                href="https://discord.gg/hHgpWwUg82"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-purple-300 transition-colors duration-300"
              >
                Join our Discord
              </a>
            </div>
          </motion.div>

          {/* Divider */}
          <div className="w-32 h-1 bg-gradient-to-r from-red-500 to-purple-500 rounded-full mx-auto mb-6"></div>

          {/* Copyright */}
          <motion.p
            className="text-gray-400 text-sm"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            viewport={{ once: true }}
          >
            © 2024 Crimson Guild. All rights reserved. | Forge your legend with us.
          </motion.p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;